var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal__wrap",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('closeModal')}}},[_c('div',{staticClass:"modal__con",on:{"click":function($event){$event.stopPropagation();}}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }